import styled from "styled-components";

export const Container = styled.div`
  h1 {
    margin-left: 16px;
  }
`;
